import React from "react";
import PanelSegmentType from "../../components/panels/PanelSegment/PanelSegment";
import LinkedShows from "./LinkedShows";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";

interface Props {
  queryKey: any[]
  config: server.dto.LinkedShowPanelConfig
  onShowsChanged: (shows: server.dto.ShowForListInternal[]) => void
  documentType: server.dto.DocumentTypes
  defaultBookkeeping: server.dto.BookkeepingSmall
  initialShowCount: number
}

const LinkedShowsPanel = (props: Props) => {
  const [displayLinkShowsModal, setDisplayLinkShowsModal] = React.useState(false);
  return <SectionPanel.Panel
    header={<>
      <PanelSegmentType.Title title={site.currentEnvironment.show.plural} />
      <PanelSegmentType.Button onClick={() => { setDisplayLinkShowsModal(true); }} label={RESX.GeneralLabels.Link} type="secondary" />
    </>}
  >
    <LinkedShows
      documentType={props.documentType}
      displayLinkShowsModal={displayLinkShowsModal}
      onDisplayLinkShowsModalToggled={() => { setDisplayLinkShowsModal(!displayLinkShowsModal); }}
      queryKey={props.queryKey}
      onShowsChange={props.onShowsChanged}
      config={props.config}
      defaultBookkeeping={props.defaultBookkeeping}
      initialShowCount={props.initialShowCount}
    />
  </SectionPanel.Panel>;
};

export default LinkedShowsPanel;